import { Box } from '@mui/material';
import styles from '../AuthMainForm.module.css';
import React from 'react';

interface AuthTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  className?: string;
}

export const AuthTabPanel = (props: AuthTabPanelProps) => {
  const { children, value, index, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`auth-tabpanel-${index}`}
      aria-labelledby={`auth-tab-${index}`}
      className={className}
      {...other}
    >
      {value === index && <Box className={styles.panel}>{children}</Box>}
    </div>
  );
};
